var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 49.233,
    height: 42.981,
    viewBox: "0 0 49.233 42.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_576",
    "data-name": "Rectangle 576",
    width: 49.233,
    height: 42.981,
    fill: "#de1a28"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10511",
    "data-name": "Group 10511",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10349",
    "data-name": "Group 10349",
    transform: "translate(-0.001 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27729",
    "data-name": "Path 27729",
    d: "M36.627,5.153h3.705a8.928,8.928,0,0,1,8.9,8.9v20.03a8.923,8.923,0,0,1-8.9,8.9H8.9a8.923,8.923,0,0,1-8.9-8.9V14.054a8.928,8.928,0,0,1,8.9-8.9h3.7a6.979,6.979,0,0,1,1.876-2.935A7.718,7.718,0,0,1,19.392,0h10.45a7.73,7.73,0,0,1,4.912,2.217,6.927,6.927,0,0,1,1.873,2.935M24.615,13.22A10.852,10.852,0,1,1,16.946,16.4a10.824,10.824,0,0,1,7.669-3.178m5.313,5.537a7.522,7.522,0,1,0,2.2,5.31,7.494,7.494,0,0,0-2.2-5.31m10.4-10.265H35.213a1.669,1.669,0,0,1-1.669-1.67,3.168,3.168,0,0,0-1.1-2.208,4.242,4.242,0,0,0-2.6-1.276H19.392a4.249,4.249,0,0,0-2.606,1.276,3.186,3.186,0,0,0-1.1,2.208,1.667,1.667,0,0,1-1.667,1.67H8.9a5.585,5.585,0,0,0-5.563,5.562v20.03A5.585,5.585,0,0,0,8.9,39.645H40.332a5.583,5.583,0,0,0,5.563-5.562V14.054a5.583,5.583,0,0,0-5.563-5.562",
    transform: "translate(0 0)",
    fill: "#de1a28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/camera_icon.8af67877cd97ecce34d4e0f578f22302.svg";
export { ForwardRef as ReactComponent };